/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AwaitingFreelancerComplianceResource
 */
export interface AwaitingFreelancerComplianceResource extends ProjectDeliverablePaymentResource {
}

/**
 * Check if a given object implements the AwaitingFreelancerComplianceResource interface.
 */
export function instanceOfAwaitingFreelancerComplianceResource(value: object): value is AwaitingFreelancerComplianceResource {
    return true;
}

export function AwaitingFreelancerComplianceResourceFromJSON(json: any): AwaitingFreelancerComplianceResource {
    return AwaitingFreelancerComplianceResourceFromJSONTyped(json, false);
}

export function AwaitingFreelancerComplianceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwaitingFreelancerComplianceResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function AwaitingFreelancerComplianceResourceToJSON(value?: AwaitingFreelancerComplianceResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
    };
}

